import React from 'react';
import PropTypes from 'prop-types';
import Isvg from 'react-inlinesvg';

import Message from 'components/Message';
import { TooltipContent, TooltipToggle } from 'components/Tooltip';
import When from 'components/When';
import { ICONS } from 'constants/icons';
import { bem } from 'helpers/class-name';

import { messages } from '../Services.messages';
import ServicesListItemMetadata from './ServicesListItemMetadata';

const { element } = bem('services-list-item');

const LegacyServicesListItemContent = ({
  duration,
  equipmentLength,
  hasPrice,
  isDisabled,
  name,
  practitionersLength,
}) => (
  <>
    <When predicate={!hasPrice}>
      <TooltipToggle name="service-pending-review-tooltip">
        <Isvg src={ICONS.clock} className={element('pending-review-icon')} />
      </TooltipToggle>
      <TooltipContent name="service-pending-review-tooltip" idempotent>
        <Message message={messages.list.pendingReviewTooltip} />
      </TooltipContent>
    </When>
    <ServicesListItemMetadata
      duration={duration}
      equipmentLength={equipmentLength}
      isDisabled={isDisabled}
      name={name}
      practitionersLength={practitionersLength}
    />
  </>
);

LegacyServicesListItemContent.propTypes = {
  duration: PropTypes.string,
  equipmentLength: PropTypes.number,
  hasPrice: PropTypes.bool,
  isDisabled: PropTypes.bool,
  name: PropTypes.string,
  practitionersLength: PropTypes.number,
};

export default LegacyServicesListItemContent;
